import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'previousWeekLevelCategory'
})
export class PreviousWeekLevelCategoryPipe implements PipeTransform {
  transform(previousWeekLevel: number) {
    if (previousWeekLevel <= 2) {
      return 'red';
    } else if (previousWeekLevel <= 5) {
      return 'yellow';
    }
    return 'green';
  }
}
